import React from 'react';
import { Card, CardsContainer, IResponsiveImageSource } from '../../../ui';

const exampleImageSource =
	'https://cdn.images.express.co.uk/img/dynamic/24/590x/Tesla-Roadster-0-60mph-881815.jpg';

const exampleResponsiveImageSource: IResponsiveImageSource = [
	exampleImageSource,
	{ mobile: `https://demo.cloudimg.io/crop/240x240/n/${exampleImageSource}` },
];

const defaultCard = (
	<Card
		title="Other title"
		imageSource={exampleImageSource}
		imageAlt="Some image"
		linkHref="https://www.google.com"
	>
		<p>Some other text</p>
	</Card>
);

const defaultResponsiveCard = (
	<Card
		title="Other title"
		imageSource={exampleResponsiveImageSource}
		imageAlt="Some responsive image"
		linkHref="https://www.google.com"
	>
		<p>Some other text</p>
	</Card>
);

export const Cards = () => (
	<>
		<h2 id="cards">Cards</h2>

		<h3>Vertical card</h3>
		<CardsContainer
			columns={[3, { mobile: 1 }]}
			cardOrientation="vertical"
			titleFontSize={[32, { mobileXL: 24, mobile: 20 }]}
		>
			{defaultCard}
			{defaultCard}
			{defaultCard}
		</CardsContainer>
		<br />
		<br />
		<h3>Vertical card, horizontal on mobile</h3>
		<CardsContainer
			columns={[3, { mobile: 1 }]}
			cardOrientation={['vertical', { mobile: 'horizontal' }]}
			titleFontSize={[32, { mobileXL: 24, mobile: 16 }]}
		>
			<Card
				title="Some flights"
				imageSource={exampleResponsiveImageSource}
				imageAlt="Some responsive image"
				linkTitle="More flights"
				linkHref="/flights"
			>
				<p>
					Some text some Some text some text Some text some Some text some text
					Some text some Some text some text
				</p>
			</Card>
			{defaultResponsiveCard}
			{defaultResponsiveCard}
		</CardsContainer>
		<br />
		<br />
		<h3>Fully Clickable, vertical card, 1 column on mobile</h3>
		<CardsContainer
			fullyClickable
			columns={[3, { mobile: 1 }]}
			cardOrientation="vertical"
			titleFontSize={[32, { mobileXL: 24, mobile: 20 }]}
		>
			{defaultCard}
			{defaultCard}
			{defaultCard}
		</CardsContainer>
		<br />
		<h3>Fully Clickable, vertical card, 2 columns on mobile</h3>
		<CardsContainer
			fullyClickable
			columns={[3, { tablet: 2 }]}
			cardOrientation="vertical"
			titleFontSize={[32, { mobileXL: 24, mobile: 16 }]}
			linkHidden={[false, { tablet: true }]}
			childrenHidden={[false, { mobileXL: true }]}
		>
			<Card
				title="Find all our services our services"
				imageSource={exampleImageSource}
				imageAlt="Some image"
				linkTitle="More flights"
				linkHref="/flights"
			>
				<p>
					Some text some text Some text some text Some text some text Some text
					some text
				</p>
			</Card>
			{defaultCard}
			{defaultCard}
			{defaultCard}
			{defaultCard}
		</CardsContainer>
		<br />
		<h3>Fully Clickable, vertical card, and horizontal on mobile</h3>
		<CardsContainer
			fullyClickable
			columns={[3, { tablet: 2, mobile: 1 }]}
			cardOrientation={['vertical', { mobile: 'horizontal' }]}
			titleFontSize={[32, { mobileXL: 24 }]}
			linkHidden={[false, { tablet: true }]}
			childrenHidden={[false, { mobileXL: true }]}
		>
			<Card
				title="Find all our services our services"
				imageSource={exampleResponsiveImageSource}
				imageAlt="Some responsive image"
				linkTitle="More flights"
				linkHref="/flights"
			>
				<p>
					Some text some text Some text some text Some text some text Some text
					some text
				</p>
			</Card>
			{defaultResponsiveCard}
			{defaultResponsiveCard}
			{defaultResponsiveCard}
			{defaultResponsiveCard}
		</CardsContainer>
	</>
);
